import React, { useEffect, useState } from 'react'
import { ProductMessageItem } from '../../ChatMessages/types'
import { isDigitalGiftExperience } from '@moonpig/web-shared-products'
import { DepartmentsEnum } from '@moonpig/web-shared-types-graphql/graphqlTypes'
import { ConciergeGiftTileContent } from '../ConciergeGiftTileContent'
import { useConciergeAddToBasket } from './useConciergeAddToBasket'
import {
  StyledGiftButton,
  StyledGiftLink,
  StyledGiftTileContainer,
} from './styled'

type ConciergeGiftTileProps = {
  item: ProductMessageItem
  itemId?: string
  onBasketClick?: (item: ProductMessageItem) => void
  onBasketAddStarted?: (item: ProductMessageItem) => void
  onBasketAdded?: (item: ProductMessageItem) => void
  onBasketAddFailed?: (item: ProductMessageItem) => void
  onTileClick?: (item: ProductMessageItem) => void
}

export const ConciergeGiftTile = ({
  item,
  onBasketClick,
  onBasketAddStarted,
  onBasketAdded,
  onBasketAddFailed,
  onTileClick,
}: ConciergeGiftTileProps) => {
  const { isBasketLoading, isBasketConfirmed, handleBasketClick } =
    useConciergeAddToBasket(
      item,
      onBasketClick,
      onBasketAddStarted,
      onBasketAdded,
      onBasketAddFailed,
    )

  const [showBasketButton, setShowBasketButton] = useState(false)

  useEffect(() => {
    setShowBasketButton(
      !isDigitalGiftExperience(item.category?.department as DepartmentsEnum),
    )
  }, [item.category?.department])

  if (item.productUrl) {
    return (
      <StyledGiftTileContainer>
        <ConciergeGiftTileContent
          isBasketConfirmed={isBasketConfirmed}
          isBasketLoading={isBasketLoading}
          item={item}
          onBasketClick={showBasketButton ? handleBasketClick : undefined}
          showBasketBadge={showBasketButton}
        />
        <StyledGiftLink
          aria-label={item.title}
          draggable={false}
          href={item.productUrl}
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()
            onTileClick?.(item)
          }}
          rel="noreferrer noopener"
          target="_blank"
        />
      </StyledGiftTileContainer>
    )
  }

  return (
    <StyledGiftButton type="button" onClick={() => onTileClick?.(item)}>
      <StyledGiftTileContainer>
        <ConciergeGiftTileContent
          item={item}
          showBasketBadge={showBasketButton}
        />
      </StyledGiftTileContainer>
    </StyledGiftButton>
  )
}
